/**
 * Ordering for category pickers.
 *
 * The API returns categories alphabetically, which is what the management
 * screen wants. A picker during data entry wants the opposite: the handful of
 * categories a user actually spends in should be reachable without scrolling.
 * `transaction_count` comes from the same `/categories` response, so this is a
 * pure reordering — no extra request and no extra state.
 *
 * Ties fall back to case-insensitive name so the list is stable: a fresh user,
 * whose counts are all zero, still sees the alphabetical order.
 */
export function sortCategoriesByUsage(list) {
  return [...(list || [])].sort((a, b) => {
    const used = (b?.transaction_count || 0) - (a?.transaction_count || 0);
    if (used) return used;
    return String(a?.name || "").localeCompare(String(b?.name || ""), undefined, {
      sensitivity: "base",
    });
  });
}
